import { driverModel } from '~/entities/Driver'

export const useRefreshPage = () => {
  const refreshPage = async () => {
    await driverModel.getDriverFx()
  }

  return { refreshPage }
}
